export default __webpack_public_path__ + "static/media/Alert.2d7e20f1.svg";